import { putPromise } from "./request-promise";

// TODO
export function updateFragSizeRangeFineGoals(fragSizeRangeFineGoalParams:any) {
	return putPromise(
		'/api/dashboards/highchart_analytics/update_fines_goal',
		fragSizeRangeFineGoalParams,
		(data) => data || null
	);
}
